import axios from 'axios';
import { Dispatch } from 'redux';
import {
	SEARCH_SUGGESTIONS_REQUEST,
	SEARCH_SUGGESTIONS_SUCCESS,
	SEARCH_SUGGESTIONS_FAIL,
	CLEAR_SEARCH_SUGGESTIONS,
} from './index';
const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:4000';

export const getSearchSuggestions =
	(query: string) => async (dispatch: Dispatch) => {
		if (!query || query.trim().length < 3) {
			dispatch({ type: CLEAR_SEARCH_SUGGESTIONS });
			return;
		}
		const config = {
			headers: {
				'x-auth-token': localStorage.getItem('x-auth-token'),
			},
		};
		try {
			dispatch({ type: SEARCH_SUGGESTIONS_REQUEST });

			const { data } = await axios.post(
				BASE_URL + `/api/search-products`,
				{
					searchTerm: query,
				},
				config
			);

			dispatch({ type: SEARCH_SUGGESTIONS_SUCCESS, payload: data });
		} catch (error: any) {
			const message = error.response?.data?.message || error.message;
			dispatch({ type: SEARCH_SUGGESTIONS_FAIL, payload: message });
		}
	};
